import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/hooks/useAuth";

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        if (data?.special_1000_granted) {
          sessionStorage.setItem("kalki_special_1000", "1");
        }
      } catch (e) {}
      // Preserve the user's intended destination through the Google
      // OAuth round-trip: `login(next?)` persisted it before leaving.
      // Belt-and-suspenders: if the OAuth round-trip itself landed us on
      // an /admin* URL (because the redirect= pointed there), default to
      // /admin — never dump an authenticated admin on /app/chat.
      const here = window.location.pathname || "";
      let dest = here.startsWith("/admin") ? "/admin" : "/app/chat";
      try {
        const stored = sessionStorage.getItem("kalki_post_login_next");
        if (stored && stored.startsWith("/") && !stored.startsWith("//")) {
          dest = stored;
          sessionStorage.removeItem("kalki_post_login_next");
        }
      } catch (_) {}
      // Clean the hash so refresh won't retry.
      window.history.replaceState({}, document.title, dest);
      navigate(dest, { replace: true });
    })();
  }, [navigate]);

  return (
    <div className="w-screen h-screen flex items-center justify-center" style={{background:"#FAFAFC",backgroundImage:"radial-gradient(#DCE2EA 1px, transparent 1px)",backgroundSize:"24px 24px"}}>
      <div className="text-[#676773] tracking-[0.4em] text-xs uppercase">Weaving your path…</div>
    </div>
  );
}
